import { render, staticRenderFns } from "./Occasiongift.vue?vue&type=template&id=fc1fdfba"
import script from "./Occasiongift.vue?vue&type=script&lang=js"
export * from "./Occasiongift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports